import { pluralize, snakecase } from "web/services/inflector"

const SSR_SUPPORTED_TILE_SETTINGS = {
  deal: { galleries: true, statistics: true },
  deal_asset: { statistics: true },
  asset: { statistics: true },
}

export function openSSRTileSettingsModal({
  isTemplate,
  overviewId,
  tileId,
  tileType,
  subjectType,
  subjectId,
  fromWizard = false,
}) {
  const resource = pluralize(snakecase(subjectType))
  const query = fromWizard ? "?from_wizard=true" : ""
  const editUrl = isTemplate
    ? `/${resource}/overviews/templates/${overviewId}/tiles/${tileType}/${tileId}/edit${query}`
    : `/${resource}/${subjectId}/overviews/${overviewId}/tiles/${tileType}/${tileId}/edit${query}`

  return function () {
    window.Turbo.visit(editUrl, { frame: "modal" })
  }
}

export function supportsSSRSettingsModal(subjectType, tileType) {
  if (!subjectType) return false
  return SSR_SUPPORTED_TILE_SETTINGS[snakecase(subjectType)]?.[tileType]
}
